module.exports = __webpack_public_path__ + "img/BateriaFull.5bb60eae.svg";